import React, { useState } from 'react';
import { useAppState } from '../contexts/AppStateContext';
import { FamilySection } from '../types/ui';
import { PageHeader } from '../components/ui/PageHeader';
import { HouseRotation } from '../components/family/HouseRotation';
import { OfferBoard } from '../components/family/OfferBoard';
import { AnimalsBoard } from '../components/family/AnimalsBoard';
import { SharedLists } from '../components/family/SharedLists';
import { PollsBoard } from '../components/family/PollsBoard';
import { GoalAndWishes } from '../components/family/GoalAndWishes';
import { WeeklySummary } from '../components/family/WeeklySummary';
import { MembersList } from '../components/family/MembersList';
type Section = FamilySection | 'clani';
export function FamilyPage() {
  const {
    family,
    familyOcc,
    db
  } = useAppState();
  const [section, setSection] = useState<Section>('prevzemi');
  const openOffers = family.templates.filter(t => familyOcc[t.id]?.offer && !familyOcc[t.id]?.takenBy).length;
  const openPolls = db.polls.filter(p => p.familyId === family.id && p.open).length;
  const sections: {
    id: Section;
    label: string;
    badge?: number;
    show: boolean;
  }[] = [{
    id: 'prevzemi',
    label: 'Na voljo za prevzem',
    badge: openOffers,
    show: true
  }, {
    id: 'opravila',
    label: 'Hišna opravila',
    show: family.modules.hisnaOpravila
  }, {
    id: 'zivali',
    label: 'Živali',
    show: family.modules.zivali
  }, {
    id: 'seznami',
    label: 'Nakupi in seznami',
    show: family.modules.skupniSeznami
  }, {
    id: 'glasovanja',
    label: 'Glasovanja',
    badge: openPolls,
    show: family.modules.skupniSeznami
  }, {
    id: 'cilj',
    label: 'Skupni cilj in želje',
    show: true
  }, {
    id: 'teden',
    label: 'Tedenski pregled',
    show: true
  }, {
    id: 'clani',
    label: 'Člani',
    show: true
  }];
  const visible = sections.filter(s => s.show);
  const active = visible.some(s => s.id === section) ? section : visible[0].id;
  return <div data-id="element-1444" data-mp="13axoa04ugn9y">
      <PageHeader title={`Družina ${family.name}`} subtitle="Skupne stvari: prevzemi, hiša, živali, seznami in dogovori." data-id="element-1445" data-mp="13ao8f5dijwhz" />
      <nav aria-label="Razdelki družine" className="-mx-4 mb-6 flex gap-2 overflow-x-auto px-4 pb-1 md:mx-0 md:flex-wrap md:px-0" data-id="element-1446" data-mp="26n6626vhmb0i">
        {visible.map(s => <button key={s.id} type="button" onClick={() => setSection(s.id)} aria-current={active === s.id ? 'page' : undefined} className={`inline-flex h-10 shrink-0 items-center gap-2 whitespace-nowrap rounded-full px-4 text-sm font-bold transition-colors duration-150 ${active === s.id ? 'bg-ink text-white' : 'bg-surface text-ink shadow-pressSoft hover:bg-line/40'}`} data-id="element-1447" data-mp="2fmjgb1rfr3ma">
            {s.label}
            {s.badge ? <span className={`rounded-full px-1.5 text-xs ${active === s.id ? 'bg-white/20' : 'bg-accent text-white'}`} data-id="element-1448" data-mp="2ubxt6ju8036f">{s.badge}</span> : null}
          </button>)}
      </nav>
      {active === 'prevzemi' && <OfferBoard data-id="element-1449" data-mp="33cvtar1jfqjq" />}
      {active === 'opravila' && <HouseRotation data-id="element-1450" data-mp="3mxe0xrgnl7t1" />}
      {active === 'zivali' && <AnimalsBoard data-id="element-1451" data-mp="3mxnoz9i514w3" />}
      {active === 'seznami' && <SharedLists data-id="element-1452" data-mp="3rvxkjl7ry7i8" />}
      {active === 'glasovanja' && <PollsBoard data-id="element-1453" data-mp="3rvp9lyv7pc9o" />}
      {active === 'cilj' && <GoalAndWishes data-id="element-1454" data-mp="3cyyg2687yurz" />}
      {active === 'teden' && <WeeklySummary data-id="element-1455" data-mp="3cy58j31fs18s" />}
      {active === 'clani' && <MembersList data-id="element-1456" data-mp="3hy1ayxuhjkm8" />}
    </div>;
}